module.exports = __webpack_public_path__ + "static/img/4.36728e1.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/1/zh/4.png
// module id = sdyN
// module chunks = 0